import React, { Children } from 'react';
import { motion } from 'framer-motion';
const cards = [{
  emoji: '😟',
  title: 'Síntomas sin explicación',
  text: 'Tu mascota tiene problemas de piel, digestión o energía y no sabés por qué, a pesar de cuidarla bien.'
}, {
  emoji: '🔍',
  title: 'Ingredientes misteriosos',
  text: 'Comprás balanceado caro pensando que es lo mejor, pero los ingredientes son un verdadero misterio.'
}, {
  emoji: '🥦',
  title: 'No sabés por dónde empezar',
  text: 'Querés darle comida natural pero no tenés idea de las cantidades correctas ni cómo hacer la transición.'
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 30
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6
    }
  }
};
export function PainPoints() {
  return <section className="bg-white py-24 px-6" data-id="element-35" data-mp="3nbmn5yw2mnux">
      <div className="max-w-6xl mx-auto" data-id="element-36" data-mp="3nabm46u0fu7i">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-[2rem] md:text-[2.4rem] text-brand-darkgreen text-center mb-16 leading-tight" data-id="element-37" data-mp="1yzn3xk05p8g3">
          ¿Te identificás con alguna de estas situaciones?
        </motion.h2>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-38" data-mp="1g2ly5wys34b3">
          {cards.map((card, index) => <motion.div key={index} variants={itemVariants} className="bg-brand-cream rounded-2xl p-8 border-l-[6px] border-brand-medgreen shadow-[0_4px_20px_rgba(0,0,0,0.05)]" data-id="element-39" data-mp="1p04mpbbms0rq" data-mpi={index}>
              <div className="text-4xl mb-6" data-id="element-40" data-mp="30fta23ssr1t2">{card.emoji}</div>
              <h3 className="font-sans font-bold text-xl text-brand-text mb-4" data-id="element-41" data-mp="2vjcl57drwjex">
                {card.title}
              </h3>
              <p className="text-brand-gray leading-relaxed" data-id="element-42" data-mp="1t4n4qkcdn5bd">{card.text}</p>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}